import { render } from "./ChatThread.vue?vue&type=template&id=f5dbba78&scoped=true&ts=true"
import script from "./ChatThread.vue?vue&type=script&lang=ts"
export * from "./ChatThread.vue?vue&type=script&lang=ts"

import "./ChatThread.vue?vue&type=style&index=0&id=f5dbba78&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5dbba78"]])

export default __exports__